import { render } from "./App.vue?vue&type=template&id=52792982"
const script = {}

import "./App.vue?vue&type=style&index=0&id=52792982&lang=scss"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__